import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';

import { AclDataModule } from '../acl-data/acl-data.module';
import { AngularMaterialModule } from '../angular-material.module';
import { AddNotificationDialogComponent } from './add-notification-dialog/add-notification-dialog.component';
import { AutofocusDirective } from './autofocus/autofocus.AutofocusDirective';
import { CommentDialogComponent } from './comment-dialog/comment-dialog.component';
import { CommentsViewComponent } from './comments-view/comments-view.component';
import { DocumentPropertiesEditComponent } from './document-properties-edit/document-properties-edit.component';
import { EventNotificationViewComponent } from './event-notification-view/event-notification-view.component';
import { MultiselectEmailComponent } from './multiselect-email/multiselect-email.component';
import { MultiselectWrapperComponent } from './multiselect-wrapper/multiselect-wrapper.component';
import { PermissionDialogComponent } from './permission-dialog/permission-dialog.component';
import { PermissionsComponent } from './permissions/permissions.component';
import { ReasonDialogComponent } from './reason-dialog/reason-dialog.component';
import { SystemNotificationViewComponent } from './system-notification-view/system-notification-view.component';

// import { AutofocusDirective } from './autofocus/autofocus.AutofocusDirective';

@NgModule({
    declarations: [
        MultiselectWrapperComponent,
        EventNotificationViewComponent,
        AddNotificationDialogComponent,
        DocumentPropertiesEditComponent,
        CommentsViewComponent,
        SystemNotificationViewComponent,
        ReasonDialogComponent,
        MultiselectEmailComponent,
        CommentDialogComponent,
        PermissionsComponent,
        PermissionDialogComponent,
        AutofocusDirective,
    ],
    imports: [
        CommonModule,
        FormsModule,
        AngularMultiSelectModule,
        AngularMaterialModule,
        RouterModule.forChild([]),
        AclDataModule,
    ],
    exports: [
        MultiselectWrapperComponent,
        EventNotificationViewComponent,
        DocumentPropertiesEditComponent,
        CommentsViewComponent,
        SystemNotificationViewComponent,
        MultiselectEmailComponent,
        PermissionsComponent,
        AutofocusDirective,
    ],
    entryComponents: [
        AddNotificationDialogComponent,
        ReasonDialogComponent,
        CommentDialogComponent,
        PermissionDialogComponent,
    ],
})
export class SharedControlsModule {}
